import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import AddressTypeForm from './AddressTypeForm';

const AddressTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const AddressTypeCreate = (props: any) => {
  return (
    <Create actions={<AddressTypeActions {...props} />} {...props}>
      <AddressTypeForm />
    </Create>
  );
};

export default AddressTypeCreate;
